module.exports = __webpack_public_path__ + "static/media/3DPPA2.18fb7596.jpg";